module.exports = __webpack_public_path__ + "img/placeholder-gallery.d3b7ffe6.svg";